<span class="planthunter-nav-count" *ngIf="newHunts > 0">{{newHunts}}</span>